import { useState } from "react";
import ButtonPlain from "../../../../../general-ui/button-plain/button-plain";
import { ICONS } from "../../../../../general-ui/icon";
import ModalComponent from "../../../../../general-ui/modal/modal";
import TabHeader from "../../../../../general-ui/tab-header/tab-header";
import EditTabsList from "./edit-tabs-list/edit-tabs-list";
import TabsLayout from "./tabs-layout";

const TABS = ['Layout', 'Tabs'];

const EditSessionTabs: React.FC = () => {
	const [openModal, setOpenModal] = useState(false);
	const [activeTab, setActiveTab] = useState(TABS[0]);

	const handleOpen = () => {
		setOpenModal(true);
	};

	const handleClose = () => {
		setOpenModal(false);
	};

	const renderTabBody = () => {
		switch (activeTab) {
			case TABS[0]:
				return <TabsLayout handleClose={handleClose} />;
			case TABS[1]:
				return <EditTabsList />;
			default:
				return null;
		}
	};

	return (
		<>
			<ButtonPlain
				icon={ICONS.EDIT}
				onclick={handleOpen}
				iconSize={12}
				className="session-tab-button"
			>Edit</ButtonPlain>
			<ModalComponent
				open={openModal}
				closeable={false}
				cancellable
				closeOnEscape
				onRequestClose={handleClose}
				noPadding
				hideHeader
			>
				<div className="session-tab-layout-modal-header">
					<h4>Session Details</h4>
					<div className="session-tab-layout-tabs-container">
						<div className="session-tab-layout-tabs">
							<TabHeader
								tabs={TABS}
								onClick={value => setActiveTab(value)}
							/>
						</div>
						<div className="header-underline" />
					</div>
				</div>
				<div className="session-tab-layout-tabs-content">
					{renderTabBody()}
				</div>
			</ModalComponent>
		</>
	);
};

export default EditSessionTabs;
